import React, { CSSProperties, PropsWithChildren, memo, useEffect } from "react";
import { FORCE_MOBILE_SHELL_WIDTH } from "@/Core/utils/hooks/useScreenDesign";
import { MOBILE_CENTERED_SHELL_PORTAL_ROOT_ID } from "./portal";
import styles from "./index.module.less";

const MobileCenteredShell = ({ children }: PropsWithChildren) => {
  useEffect(() => {
    const syncBodyShellVars = () => {
      const shellWidth = Math.min(window.innerWidth, FORCE_MOBILE_SHELL_WIDTH);
      const visualViewport = window.visualViewport;
      const visualViewportBottom = visualViewport
        ? Math.max(
            0,
            window.innerHeight - visualViewport.height - visualViewport.offsetTop
          )
        : 0;

      document.body.dataset.mobileCenteredShellActive = "true";
      document.body.style.setProperty(
        "--mobile-centered-shell-width",
        `${FORCE_MOBILE_SHELL_WIDTH}px`
      );
      document.body.style.setProperty(
        "--mobile-design-shell-width",
        `${shellWidth}px`
      );
      document.body.style.setProperty(
        "--mobile-design-vw",
        `${shellWidth / 100}px`
      );
      document.body.style.setProperty(
        "--mobile-visual-viewport-bottom",
        `${visualViewportBottom}px`
      );
    };

    const visualViewport = window.visualViewport;

    syncBodyShellVars();
    window.addEventListener("resize", syncBodyShellVars);
    if (visualViewport) {
      visualViewport.addEventListener("resize", syncBodyShellVars);
      visualViewport.addEventListener("scroll", syncBodyShellVars);
    }

    return () => {
      window.removeEventListener("resize", syncBodyShellVars);
      if (visualViewport) {
        visualViewport.removeEventListener("resize", syncBodyShellVars);
        visualViewport.removeEventListener("scroll", syncBodyShellVars);
      }
      delete document.body.dataset.mobileCenteredShellActive;
      document.body.style.removeProperty("--mobile-centered-shell-width");
      document.body.style.removeProperty("--mobile-design-shell-width");
      document.body.style.removeProperty("--mobile-design-vw");
      document.body.style.removeProperty("--mobile-visual-viewport-bottom");
    };
  }, []);

  const shellStyle = {
    "--mobile-centered-shell-width": `${FORCE_MOBILE_SHELL_WIDTH}px`,
  } as CSSProperties;

  return (
    <div className={styles.shellBackdrop} style={shellStyle}>
      <div className={styles.shellViewport}>
        <div
          id={MOBILE_CENTERED_SHELL_PORTAL_ROOT_ID}
          className={styles.portalRoot}
        />
        {children}
      </div>
    </div>
  );
};

export default memo(MobileCenteredShell);
